// AUTO-GENERATED SQL Builder (V40 Final) for VendorVerification
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class VendorVerificationSql {
  private ast = new SqlAst('VendorVerification', 'vendorVerification');
  public readonly main: any = {};

  public guid: SqlField;
  public vendorId: SqlField;
  public checkType: SqlField;
  public status: SqlField;
  public referenceValue: SqlField;
  public verifiedDate: SqlField;
  public notes: SqlField;
  public documentUrl: SqlField;
  public rejectionReason: SqlField;
  public rejectionCode: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('vendorVerification', 'guid', '', 'id', 'vendorVerification_guid');
    this.vendorId = new SqlField('vendorVerification', 'vendorId', 'vendor', 'id', 'vendorVerification_vendor');
    this.checkType = new SqlField('vendorVerification', 'checkType', '', 'id', 'vendorVerification_checkType');
    this.status = new SqlField('vendorVerification', 'status', '', 'id', 'vendorVerification_status');
    this.referenceValue = new SqlField('vendorVerification', 'referenceValue', '', 'id', 'vendorVerification_referenceValue');
    this.verifiedDate = new SqlField('vendorVerification', 'verifiedDate', '', 'id', 'vendorVerification_verifiedDate');
    this.notes = new SqlField('vendorVerification', 'notes', '', 'id', 'vendorVerification_notes');
    this.documentUrl = new SqlField('vendorVerification', 'documentUrl', '', 'id', 'vendorVerification_documentUrl');
    this.rejectionReason = new SqlField('vendorVerification', 'rejectionReason', '', 'id', 'vendorVerification_rejectionReason');
    this.rejectionCode = new SqlField('vendorVerification', 'rejectionCode', '', 'id', 'vendorVerification_rejectionCode');
    this.createdByUser = createNavHybrid('vendorVerification', 'vendorVerification_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('vendorVerification', 'vendorVerification_updatedByUser', 'User');
    this.vendor = createNavHybrid('vendorVerification', 'vendorVerification_vendor', 'Vendor');
    this.id = new SqlField('vendorVerification', 'id', '', 'id', 'vendorVerification_id');
    this.isDeleted = new SqlField('vendorVerification', 'isDeleted', '', 'id', 'vendorVerification_isDeleted');
    this.createdBy = new SqlField('vendorVerification', 'createdBy', '', 'id', 'vendorVerification_createdBy');
    this.createdDate = new SqlField('vendorVerification', 'createdDate', '', 'id', 'vendorVerification_createdDate');
    this.updatedBy = new SqlField('vendorVerification', 'updatedBy', '', 'id', 'vendorVerification_updatedBy');
    this.updatedDate = new SqlField('vendorVerification', 'updatedDate', '', 'id', 'vendorVerification_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:VendorVerificationSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:VendorVerificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:VendorVerificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:VendorVerificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:VendorVerificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:VendorVerificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:VendorVerificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:VendorVerificationSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:VendorVerificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:VendorVerificationSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
